<div class="pa-select">
  <div class="pa-select__header">
    <div class="pa-select__titulo-row">
      <h3 class="pa-select__titulo">Selecionar públicos-alvo</h3>
      <button type="button" class="pa-select__fechar" (click)="onFechar()" aria-label="Fechar">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>
    <p class="pa-select__subtitle">
      Escolha os públicos-alvo que este produto deve monitorar no PLM.
    </p>
    <sgt-input-search
      class="pa-select__busca"
      placeholder="Buscar público-alvo..."
      [debounce]="200"
      (searched)="onBuscar($event)"
    ></sgt-input-search>
  </div>

  <div class="pa-select__body">
    <div *ngIf="isLoading" class="pa-select__loading">
      <i class="fas fa-spinner fa-spin"></i> Carregando públicos-alvo...
    </div>

    <ng-container *ngIf="!isLoading">
      <ul class="pa-select__lista">
        <li *ngFor="let item of itensFiltrados; trackBy: trackById" class="pa-select__item">
          <button
            type="button"
            class="pa-select__node"
            role="checkbox"
            [attr.aria-checked]="item.checked"
            (click)="toggleItem(item)"
          >
            <span
              class="pa-select__checkbox"
              [class.pa-select__checkbox--checked]="item.checked"
            >
              <i *ngIf="item.checked" class="fas fa-check" aria-hidden="true"></i>
            </span>
            <span class="pa-select__label">{{ item.nome }}</span>
          </button>
        </li>
      </ul>

      <div *ngIf="itensFiltrados.length === 0" class="pa-select__empty">
        Nenhum público-alvo encontrado.
      </div>
    </ng-container>
  </div>

  <div class="pa-select__footer">
    <span class="pa-select__contador">{{ totalSelecionados }} público(s)-alvo selecionado(s)</span>
    <div class="pa-select__footer-actions">
      <button type="button" class="btn btn-light" (click)="onFechar()">Cancelar</button>
      <button type="button" class="btn btn-primary" (click)="onConcluir()">Concluir</button>
    </div>
  </div>
</div>
